import {ApplicationController} from "../support/application-controller";

export default class extends ApplicationController {
    static targets = [
        "list",
        "loadMore"
    ];

    loadMoreOrganizations(e) {
        e.preventDefault();
        this.railsGet({url: this.data.get("loadMoreUrl"), dataType: 'application/json'})
            .then(this._onLoadMoreOrganizationsResponse.bind(this));
    }

    _onLoadMoreOrganizationsResponse(response) {
        const payload = this._normalizeResponse(response);
        if (!payload || !payload.html) return;

        this.listTarget.insertAdjacentHTML("beforeend", payload.html);

        const shouldShowButton = typeof payload.canLoadMore === "boolean"
            ? payload.canLoadMore
            : this._shouldShowLoadMore(payload.childElementCount);

        if (shouldShowButton) this.loadMoreTarget.classList.remove('project-list__load-more--hidden');
        else this.loadMoreTarget.classList.add('project-list__load-more--hidden');

        const hasNewSubscriptions = payload.detail && payload.detail.subscriptions && payload.detail.subscriptions.length;
        const hasTableRows = payload.detail && payload.detail.tableRows;
        if (hasNewSubscriptions || hasTableRows) {
            this.element.dispatchEvent(new CustomEvent("subscriptions:appended", {
                detail: {
                    ...payload.detail,
                    canLoadMore: payload.canLoadMore
                },
                bubbles: true
            }));
        }
    }

    _normalizeResponse(response) {
        if (!response) return null;

        if (typeof response === "string") {
            return {
                html: response,
                childElementCount: this._countElements(response)
            };
        }

        if (response.body && typeof response.body === "string") {
            return {
                html: response.body,
                childElementCount: this._countElements(response.body),
                canLoadMore: response.can_load_more,
                detail: {
                    subscriptions: response.subscriptions || [],
                    tableRows: response.table_rows || ""
                }
            };
        }

        if (response.body && response.body.innerHTML !== undefined) {
            return {
                html: response.body.innerHTML,
                childElementCount: response.body.childElementCount
            };
        }

        return null;
    }

    _countElements(html) {
        if (!html) return 0;
        const template = document.createElement("template");
        template.innerHTML = html.trim();
        return template.content.childElementCount;
    }

    _shouldShowLoadMore(childElementCount) {
        const limit = parseInt(this.data.get("loadLimit"), 10);
        return !!(limit && childElementCount === limit);
    }
}
